import $ from "jquery"
import { googleTagManagerEnhancedEcommerceSignUpSuccess } from "./googleAnalytics"

function signup() {
    $(document).ready(() => {
        function csrfSafeMethod(method) {
            // these HTTP methods do not require CSRF protection
            return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
        }

        function setup_ajax() {
            var csrftoken = $("[name=csrfmiddlewaretoken]").val();

            $.ajaxSetup({
                beforeSend: function (xhr, settings) {
                    if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
                        xhr.setRequestHeader("X-CSRFToken", csrftoken);
                    }
                }
            });
        }
        setup_ajax();


        function showModal(selector) {
            $(selector).addClass("modal--open")
        }

        function hideModal(selector) {
            $(selector).removeClass("modal--open")
        }

        function handlePersonalSignup() {
            showModal(".signup-modal");
            $(".signup__form-input[data-value='personal']").trigger("click");
            $(document.body).addClass("modal-active");
        }

        function handleSignUpModal() {
            const isLandingPage = $(document.body).hasClass("landing-pages")
            $(".signup__modal-close").click(function () {
                hideModal($(this).parents(".modal"))
                $(document.body).removeClass("modal-active")
                $("#try-email").val("")
            })

            $(".signup-personal1").click(function () {
                handlePersonalSignup();
            })

            $(".signup-organization1").click(function () {
                showModal(".signup-modal")
                $(".signup__form-input[data-value='organization']").trigger("click")
                $(document.body).addClass("modal-active")
            })

            $(".get-started-button").click(function () {
                window.location.href = origin + "/call";
            })
        

            $(".signup-email").click(function () {
                let email = $(".section-promo__form #try-email")
                if (email.val().length > 0) {
                    $("#email").val(email.val())
                    email.trigger("focus")
                }
                showModal(".signup-modal")
                $(document.body).addClass("modal-active")
            })

            $(".signup-personal").click(function () {
                if (!isLandingPage) {
                    handlePersonalSignup();
                }
            })

            // $(".signup-organization").click(function () {
            //     if (!isLandingPage) {
            //         $(".signup__form-input[data-value='organization']").trigger("click")
            //         showModal(".signup-modal")
            //         $(document.body).addClass("modal-active")
            //     }
            // })

            $(".read-more-button").click(function () {
                let location = window.location.href;
                let origin = window.location.origin;

                if (location.includes("10-essential-school-technology-trends")) {
                    window.location.href = origin + "/education";
                    return 
                }

                if (location.includes("hiddenapp-education")) {
                    window.location.href = origin + "/education";
                    return 
                }
                
                if (location.includes("responsible-use-policy-a-guide-for-schools")) {
                    window.location.href = origin + "/education";
                    return 
                }
                

                if (location.includes("how-to-ensure-mobile-devices-are-secure-while-remote-working")) {
                    window.location.href = origin + "/business";
                    return 
                }

                 else {
                    window.location.href = origin;
                 }
            })

            $(".section-promo__form").submit(function (e) {
                e.preventDefault()
            })

        }
        handleSignUpModal();

        function signUpHandler() {
            let firstName = "";
            let lastName = "";
            let email = "";
            let type = "organization";
            let password1 = "";
            let password2 = "";
            let terms = false;

            $(".input-iconic-checkbox").click(function () {
                $(".input-iconic-checkbox").removeClass("active")
                $(this).addClass("active")
                type = $(this).data("value")
            })

            $(".signup-submit").click(function (e) {
                e.preventDefault()
                clearMessages()

                if (isValid()) {

                    $(document.body).addClass("loading")
                    let referrer = getCookie('mp_referrer')
                    let utm_source = getCookie('utm_source')
                    let utm_medium = getCookie('utm_medium')
                    let utm_campaign = getCookie('utm_campaign')
                    if (referrer === null) referrer = document.referrer
                    $.post(window.location.origin+"/user/signup/", {
                            first_name: firstName,
                            last_name: lastName,
                            email: email,
                            type: type,
                            password1: password1,
                            password2: password2,
                            referrer: referrer,
                            utm_source: utm_source,
                            utm_medium: utm_medium,
                            utm_campaign: utm_campaign
                        })

                        .done(function (data) {
                            hideModal(".signup-modal")
                            $(document.body).removeClass("loading")
                            let userEmail = $(".signup-success-modal").find(".signup__result-text .signup__link");
                            userEmail.text(email)
                            userEmail.attr("href", `mailto:${email}`)
                            $(".signup-modal").find(".messages").remove()
                            $(".signup__result-resend-email").attr("href", data.resend_activation_email_url_marketing)
                            showModal(".signup-success-modal")
                            $(document.body).addClass("modal-active")
                            // ga success track
                            googleTagManagerEnhancedEcommerceSignUpSuccess()
                            $FPROM.trackSignup({email: email}, function() {
                              console.log('Callback received!')
                            });
                        })
                        .fail(function (data) {
                            $(document.body).removeClass("loading")
                            if (!data.responseJSON.success) {
                                let txt = `<p class="messages messages-danger">${data.responseJSON.message}</p>`

                                if (data.responseJSON.message.password1) {
                                    txt = `<p class="messages messages-danger">${data.responseJSON.message.password1[0]}</p>`
                                }

                                if (data.responseJSON.message.password2) {
                                    txt = `<p class="messages messages-danger">${data.responseJSON.message.password2[0]}</p>`
                                }

                                if (data.responseJSON.message.email) {
                                    txt = `<p class="messages messages-danger">${data.responseJSON.message.email[0]}</p>`
                                }

                                $(".signup").find(".signup__form-message").html(txt)
                            }
                        })
                }
            })

            function getUserData() {
                console.log(terms)
                if ($("#first-name").val().trim().length > 0) {
                    firstName = $("#first-name").val().trim();
                    $("#first-name").parent().removeClass("error");
                    $("#first-name-error").hide();
                } else {
                    $("#first-name").parent().addClass("error");
                    $("#first-name-error").show();
                }

                if ($("#last-name").val().trim().length > 0) {
                    lastName = $("#last-name").val().trim();
                    $("#last-name").parent().removeClass("error");
                    $("#last-name-error").hide();
                } else {
                    $("#last-name").parent().addClass("error");
                    $("#last-name-error").show();
                }

                if ($("#email").val().trim().length > 0) {
                    email = $("#email").val().trim();
                    $("#email").parent().removeClass("error");
                    $("#email-error").hide();
                } else {
                    $("#email").parent().addClass("error");
                    $("#email-error").show();
                }

                if ($("#password").val().trim().length > 8 && isNaN($("#password").val())) {
                    password1 = $("#password").val();
                    $("#password").parent().removeClass("error");
                } else {
                    let txt = `<p class="messages messages-danger">Password must be alphanumeric and at least 9 characters long</p>`
                    $(".signup").find(".signup__form-message").html(txt)
                    $("#password").parent().addClass("error");
                }

                if ($("#password").val() != $("#confirm-password").val()) {
                    let txt = `<p class="messages messages-danger">Passwords do not match</p>`
                    $(".signup").find(".signup__form-message").html(txt)
                    $("#confirm-password").parent().addClass("error");
                } else {
                    password2 = $("#confirm-password").val();
                    $("#confirm-password").parent().removeClass("error");
                }
                if (!terms) {
                    let txt = `<p class="messages messages-danger">Please indicate that you accept the Terms and Conditions</p>`
                    $(".signup").find(".signup__form-message").html(txt)
                }
            }

            $("#signup-agreement").on("change", function() {
                terms = $(this).is(":checked")
            })

            function isValid() {
                getUserData();
                return firstName.trim().length > 0 && lastName.trim().length > 0 && email.trim().length > 0 && password1.trim().length > 8 && password2.trim().length > 8 && password1 == password2 && terms
            }

            function clearMessages() {
                $(".signup").find(".signup__form-message").html("")
                $(".signup-success-modal").find(".messages").remove()
            }
        }

        signUpHandler()

        function getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        }
        function activationEmailResendHandler() {
            $(".signup__result-resend-email").click(function (e) {
                e.preventDefault()
                let link = $(this).attr("href")

                if (link.length > 0 && link != "#") {
                    $(document.body).addClass("loading")
                    let txt = {
                        msg: "Waiting for response",
                        status: "danger"
                    }
                    $.get($(this).attr("href"))
                        .done(function (data) {
                            $(document.body).removeClass("loading")
                            if (data.success) {
                                txt.msg = "Email resent"
                                txt.status = "success"
                            } else {
                                txt.msg = "Failed to resend the activation email"
                            }
                            $(".signup-success-modal .signup__result").append(`<p style="text-align:center" class="messages messages-${txt.status}">${txt.msg}</p>`)
                        })
                        .fail(function (data) {
                            $(document.body).removeClass("loading")
                            txt.msg = "Failed to resend the activation email"
                            $(".signup-success-modal .signup__result").append(`<p style="text-align:center" class="messages messages-${txt.status}">${txt.msg}</p>`)
                        })
                }
            })
        }

        activationEmailResendHandler()

        function autoOpenSignUp() {
            let url = new URL(window.location.href)
            let isAutoOpen = url.searchParams.get("signup")

            if (isAutoOpen) {
                handlePersonalSignup();
            }
        }

        autoOpenSignUp()

        function fillFormIfPossible() {
            let url = new URL(window.location.href)
    
            let fName = url.searchParams.get("first-name")
            let lName = url.searchParams.get("last-name")
            let email = url.searchParams.get("email")
    
            if (fName) {
                $("#first-name").val(fName)
                $("#first-name").parent().addClass("active")
            }

            if (lName) {
                $("#last-name").val(lName)
                $("#last-name").parent().addClass("active")
            }

            if (email) {
                $("#email").val(email)
                $("#email").parent().addClass("active")
            }
        }

        fillFormIfPossible()
    })

    function getSelected() {
        if (window.getSelection) {
            return window.getSelection();
        } else if (document.getSelection) {
            return document.getSelection();
        } else {
            var selection = document.selection && document.selection.createRange();
            if (selection.text) {
                return selection.text;
            }
            return false;
        }
    }

    $(document).mouseup(function (e) {
        let selection = getSelected();

        if ($(e.target).hasClass("modal--open")) {

            if (selection.type != "Range") {
                $(e.target).removeClass("modal--open")
                $(document.body).removeClass("modal-active")
                $("#try-email").val("")
            }
        }
    })

    // Text Input
    const handleFocus = e => {
        const target = e.target
        target.parentNode.classList.add('active', 'focused')
        target.parentNode.classList.remove('fielded')
    }

    const handleBlur = e => {
        const target = e.target
        if (!target.value) {
            target.parentNode.classList.remove('active')
        } else {
            target.parentNode.classList.add('fielded')
        }
        target.parentNode.classList.remove('focused')
    }

    const bindEvents = input => {
        $(input).focus(handleFocus)
        $(input).blur(handleBlur)
    }

    const initFloatContainers = () => {
        $('.float-container .float-container__input').each(function () {
            if (this.value) {
                $(this).parent().addClass('active fielded')
            }

            bindEvents(this)
        })
    }

    initFloatContainers()
}

export default signup